export default __webpack_public_path__ + "static/media/womenShomizSkirt.db25ee97.svg";